// extracted by mini-css-extract-plugin
export default {"headerWrapper":"styles_headerWrapper__PzYfe"};